import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { IsLoginChecker } from '../../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { requestContext } from '../../../common/requestContext';
import { Layout } from '../../../design-system/layout/Layout';
import { TicketHistoryContainer } from '../../../domain/history/ticket/container/TicketHistoryContainer';
import { HistoryListType } from '../../../domain/history/type';
import { CommonMobileHeaderType } from '../../../header/constants';
function TicketPage() {
  const router = useRouter();
  const currentTabType = router.query?.tab === HistoryListType.Use ? HistoryListType.Use : HistoryListType.Buy;
  return <IsLoginChecker>
      <TicketHistoryContainer />
      <TrackPageViewContainer trackObj={{
      section: '더보기',
      page: `${currentTabType === HistoryListType.Buy ? '이용권내역_충전내역' : '이용권내역_사용내역'}`,
      actionType: 'Pageview',
      actionName: '이용권내역_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </IsLoginChecker>;
}
TicketPage.getLayout = function getLayout(page: ReactElement) {
  const requestInfo = requestContext.requestInfo;
  const shouldShowHeader = requestInfo?.display ? !requestInfo.display.isWebView : true;
  return <Layout title={t('more_ticket_history_title')} mobileLayoutConfig={{
    shouldShowHeader,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default TicketPage;